import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'tech-check-result',
  templateUrl: './tech-check-result.component.html',
  styleUrls: ['./tech-check-result.component.scss']
})
export class TechCheckResultComponent implements OnInit {
  showResultDetails: boolean;

  constructor() {
  }

  @Input()
  techCheckResult: any = {};

  ngOnInit() {
  }


  openResultDetails() {
    this.showResultDetails = true;
  }

}
